export default __webpack_public_path__ + "static/media/mail-to@3x.a26de897.png";